import container from './RazorpayButton.container';
import RazorpayButton from './RazorpayButton';


export default container(RazorpayButton)